import { EVENT_STATUS_CLOSED, EVENT_STATUS_FINALIZED, EVENT_STATUS_OPEN } from '@ogsnetwork/opp-api-lib';
import { createSelector } from 'reselect';
import { userTicketsByCloseSelector, userTicketsByFinalizeSelector, userTicketSelector } from './index';
const MY_CONTEST_NAVIGATION_PROP_TO_EVENT_STATUS_MAP = {
    upcoming: EVENT_STATUS_OPEN,
    live: EVENT_STATUS_CLOSED,
    completed: EVENT_STATUS_FINALIZED
};
export const eventStatusFromPropSelector = (_state, props) => {
    return MY_CONTEST_NAVIGATION_PROP_TO_EVENT_STATUS_MAP[props.status];
};
export const makeUserTicketsByStatusSelector = () => createSelector(eventStatusFromPropSelector, userTicketsByCloseSelector, userTicketsByFinalizeSelector, userTicketSelector, (eventStatus, userTicketsByClose, userTicketsByFinalize, userTickets) => {
    if (eventStatus === EVENT_STATUS_OPEN || eventStatus === EVENT_STATUS_CLOSED) {
        return userTicketsByClose.filter((ticket) => ticket.event.status === eventStatus);
    }
    if (eventStatus === EVENT_STATUS_FINALIZED) {
        return userTicketsByFinalize.filter((ticket) => ticket.event.status === eventStatus);
    }
    return userTickets;
});
